import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { BookingCancellationQuoteResponse } from "@bw/shared/types/generated";

export const cancellationQuoteQueryKey = (bookingId: string) =>
  ["booking", "cancellation-quote", bookingId] as const;

/** Fetch a new server-authored cancellation decision for each dialog request. */
export function useCancellationQuote(
  bookingId: string | undefined,
  requestVersion: number,
  enabled = true,
) {
  return useQuery<BookingCancellationQuoteResponse>({
    queryKey: [...cancellationQuoteQueryKey(bookingId ?? ""), requestVersion],
    queryFn: () =>
      facilityApi.createBookingCancellationQuote(bookingId as string),
    enabled: Boolean(bookingId) && enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
